<template>
  <div class="form" style="padding:29px 29px 0;border-bottom:1px solid #F2F2F2;">
    <span class="title">{{title}}</span>
    <el-form
      :inline="true"
      :model="conditon"
      class="demo-form-inline"
      style="margin-top:20px;"
      size="small"
    >
      <slot name="season"/>
      <el-form-item label="省份">
        <el-select
          v-model="conditon.province"
          placeholder="不限"
          style="width:100px;"
          @change="changeCity"
        >
          <el-option label="不限" value></el-option>
          <el-option
            v-show="provinceList.length"
            v-for="(item,index) in provinceList"
            :key="index"
            :label="item.provinceName"
            :value="item.provinceName+'-'+item.provinceCode"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="地市">
        <el-select v-model="conditon.city" placeholder="不限" style="width:150px;">
          <el-option label="不限" value></el-option>
          <el-option
            v-show="cityList.length"
            v-for="(item,index) in cityList"
            :key="index"
            :label="item.cityName"
            :value="item.cityCode"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="停靠石化油站次数占比">
        <el-select v-model="conditon.range" placeholder="不限" style="width:110px;">
          <el-option label="不限" value></el-option>
          <el-option label="0%" value="0-0"></el-option>
          <el-option label="0-30%" value="0-30"></el-option>
          <el-option label="30-50%" value="30-50"></el-option>
          <el-option label="50-80%" value="50-80"></el-option>
          <el-option label="80%以上" value="80-100"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="search">查询</el-button>
        <el-button @click="prev">返回上级</el-button>
        <slot name="export"/>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
/**
 * @file:  View 组件 form
 * @author: v_chengmengya
 * @date: 2019-05-15
 * @description: UI组件
 */
export default {
  props: {
    title: {
      //标题
      default: '',
      type: String
    },
    conditon: {
      // 表单数据
      defualt: () => {
        return {}
      },
      type: Object
    },
    provinceList: {
      //省份列表
      defualt: () => {
        return []
      },
      type: Array
    },
    cityList: {
      // 地市列表
      default: () => {
        return []
      },
      type: Array
    },
    search: {
      // 查询
      default: () => {},
      type: Function
    },
    prev: {
      // 返回上级
      default: () => {},
      type: Function
    },
    changeCity: {
      default: () => {},
      type: Function
    }
  },
  data() {
    return {}
  },
  methods: {
    one() {
      console.log('点击到了我')
      let that = this
      that.showSeason = false
    }
  }
}
</script>
